<template>
  <el-radio-group
    :model-value="Array.isArray(props.modelValue) ? props.modelValue[0] : props.modelValue"
    @change="(value) => emit('update:modelValue', value)"
  >
    <el-radio
      v-for="option in props.options"
      :key="option.id"
      :value="option.id"
      :disabled="option.isDisabled"
    >
      <div class="flex items-start">
        <span v-html="sanitize(option.text)" />
        <Tooltip
          v-if="option.tooltipText"
          :text="option.tooltipText"
          class="ml-1 mt-px"
        />
      </div>
      <div
        v-if="option.description"
        class="text-gray-500"
        v-html="sanitize(option.description)"
      />
    </el-radio>
  </el-radio-group>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: undefined,
  },
  options: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);
</script>
